import { render, staticRenderFns } from "./ModalDevelopmentRole.vue?vue&type=template&id=b0985a8a&scoped=true&"
import script from "./ModalDevelopmentRole.vue?vue&type=script&lang=js&"
export * from "./ModalDevelopmentRole.vue?vue&type=script&lang=js&"
import style0 from "./ModalDevelopmentRole.vue?vue&type=style&index=0&id=b0985a8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0985a8a",
  null
  
)

export default component.exports